/* eslint-disable */
import { FuseNavigationItem } from "@fuse/components/navigation";
import { Roles } from "../../../modules/admin/roles/enums/roles.enum";

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: "posts",
    titleLang: "MENU.Posts",
    title: "MENU.Posts",
    type: "basic",
    icon: "heroicons_outline:chat-bubble-bottom-center-text",
    link: "/posts",
    roles: [Roles.Admin, Roles.Collaborator],
  },
  {
    id: "users",
    titleLang: "MENU.Users",
    title: "MENU.Users",
    type: "basic",
    icon: "heroicons_outline:users",
    link: "/users",
    roles: [Roles.Admin],
  },
  // {
  //     id: 'role',
  //     titleLang: 'MENU.Roles',
  //     titleLang: 'MENU.Roles',
  //     type: 'basic',
  //     icon: 'heroicons_outline:user-group',
  //     link: '/roles',
  //     roles: [Roles.Admin],
  // },
  // {
  //     id: 'subscriptions',
  //     titleLang: 'MENU.Subscriptions',
  //     titleLang: 'MENU.Subscriptions',
  //     type: 'basic',
  //     icon: 'heroicons_outline:check-badge',
  //     link: '/subscriptions',
  //     roles: [Roles.Admin],
  // },
  {
    id: "categories",
    titleLang: "MENU.Categories",
    title: "MENU.Categories",
    type: "basic",
    icon: "heroicons_outline:square-2-stack",
    link: "/categories",
    roles: [Roles.Admin, Roles.Collaborator],
  },
  {
    id: "subcategories",
    titleLang: "MENU.SubCategories",
    title: "MENU.SubCategories",
    type: "basic",
    icon: "heroicons_outline:square-3-stack-3d",
    link: "/subcategories",
    roles: [Roles.Admin, Roles.Collaborator],
  },
  {
    id: "pages",
    titleLang: "MENU.Pages",
    title: "MENU.Pages",
    type: "basic",
    icon: "heroicons_outline:square-2-stack",
    link: "/pages",
    roles: [Roles.Admin, Roles.Collaborator],
  },
  // {
  //   id: "challenges",
  //   titleLang: "MENU.Challenges",
  //   title: "MENU.Challenges",
  //   type: "basic",
  //   icon: "heroicons_outline:arrow-trending-up",
  //   link: "/challenges",
  //   roles: [Roles.Admin, Roles.Collaborator],
  // },
  // {
  //   id: "insignias",
  //   titleLang: "MENU.Insignias",
  //   title: "MENU.Insignias",
  //   type: "basic",
  //   icon: "heroicons_outline:trophy",
  //   link: "/insignias",
  //   roles: [Roles.Admin],
  // },
  {
    id: "sections",
    titleLang: "MENU.HomeSections",
    title: "MENU.HomeSections",
    type: "basic",
    icon: "heroicons_outline:circle-stack",
    link: "/sections",
    roles: [Roles.Admin, Roles.Collaborator],
  },
  {
    id: "menu-items",
    titleLang: "MENU.MenuItems",
    title: "MENU.MenuItems",
    type: "basic",
    icon: "heroicons_outline:bars-4",
    link: "/menu-items",
    roles: [Roles.Admin, Roles.Collaborator],
  },
  {
    id: "custom-section-types",
    titleLang: "MENU.CustomSectionTypes",
    title: "MENU.CustomSectionTypes",
    type: "basic",
    icon: "heroicons_outline:adjustments-horizontal",
    link: "/custom-section-types",
    roles: [Roles.Admin, Roles.Collaborator],
  },
  {
    id: "tags",
    titleLang: "MENU.Tags",
    title: "MENU.Tags",
    type: "basic",
    icon: "heroicons_outline:tag",
    link: "/tags",
    roles: [Roles.Admin, Roles.Collaborator],
  },
  // {
  //     id: 'tiers',
  //     titleLang: 'MENU.Tiers',
  //     titleLang: 'MENU.Tiers',
  //     type: 'basic',
  //     icon: 'heroicons_outline:bars-arrow-up',
  //     link: '/tiers',
  //     roles: [Roles.Admin],
  // },
  // {
  //     id: 'notifications',
  //     titleLang: 'MENU.Notifications',
  //     titleLang: 'MENU.Notifications',
  //     type: 'basic',
  //     icon: 'heroicons_outline:envelope',
  //     link: '/notifications',
  //     roles: [Roles.Admin],
  // },
  {
    id: "template",
    titleLang: "MENU.Template",
    title: "MENU.Template",
    type: "basic",
    icon: "heroicons_outline:squares-2x2",
    link: "/template",
    roles: [Roles.Admin, Roles.Collaborator],
  },
  {
    id: "resources",
    titleLang: "MENU.Resources",
    title: "MENU.Resources",
    type: "basic",
    icon: "heroicons_outline:arrow-down-circle",
    link: "/resources",
    roles: [Roles.Admin, Roles.Collaborator],
  },
  // {
  //   id: "resource-download",
  //   titleLang: "MENU.ResouceDownload",
  //   title: "MENU.ResouceDownload",
  //   type: "basic",
  //   icon: "heroicons_outline:document-text",
  //   link: "/resource-download",
  //   roles: [Roles.Admin],
  // },
  {
    id: "questions",
    titleLang: "MENU.Onboarding",
    title: "MENU.Onboarding",
    icon: "heroicons_outline:identification",
    type: "collapsable",

    children: [
      {
        id: "pages",
        titleLang: "MENU.Pages",
        title: "MENU.Pages",
        type: "basic",
        icon: "heroicons_outline:document",
        link: "/onboarding/pages",
        roles: [Roles.Admin],
      },
      {
        id: "questions",
        titleLang: "MENU.Questions",
        title: "MENU.Questions",
        type: "basic",
        icon: "heroicons_outline:question-mark-circle",
        link: "/questions",
        roles: [Roles.Admin],
      },
      {
        id: "answers",
        titleLang: "MENU.Answers",
        title: "MENU.Answers",
        type: "basic",
        icon: "heroicons_outline:chevron-up-down",
        link: "/answers",
        roles: [Roles.Admin],
      },
    ],
  },
  // {
  //   id: "synchronization",
  //   titleLang: "MENU.Synchronization",
  //   title: "MENU.Synchronization",
  //   type: "basic",
  //   icon: "heroicons_outline:arrow-path",
  //   link: "/synchronization",
  //   roles: [Roles.Admin],
  // },
  {
    id: "operators",
    titleLang: "MENU.Operators",
    title: "MENU.Operators",
    type: "basic",
    icon: "heroicons_outline:phone",
    link: "/operators",
    roles: [Roles.Admin],
  },
  {
    id: "bps",
    titleLang: "MENU.Bps",
    title: "MENU.Bps",
    type: "basic",
    icon: "heroicons_outline:megaphone",
    link: "/bps",
    exactMatch: true,
    roles: [Roles.Admin],
  },
  {
    id: "bps-report",
    titleLang: "MENU.BpsReport",
    title: "MENU.BpsReport",
    type: "basic",
    icon: "heroicons_outline:chart-bar",
    link: "/bps/reporteria",
    roles: [Roles.Admin],
  },
  // {
  //   id: "try-and-buy",
  //   titleLang: "MENU.TryAndBuy",
  //   title: "MENU.TryAndBuy",
  //   type: "basic",
  //   icon: "heroicons_outline:credit-card",
  //   link: "/try-and-buy",
  //   roles: [Roles.Admin],
  // },

  {
    id: "global-settings",
    titleLang: "MENU.GlobalSettings",
    title: "MENU.GlobalSettings",
    type: "basic",
    icon: "heroicons_outline:cog-6-tooth",
    link: "/global-settings",
    roles: [Roles.Admin],
  },
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    titleLang: "MENU.Example",
    title: "MENU.Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
    roles: [Roles.Admin],
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    titleLang: "MENU.Example",
    title: "MENU.Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
    roles: [Roles.Admin],
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    titleLang: "MENU.Example",
    title: "MENU.Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
    roles: [Roles.Admin],
  },
];
